import { Component, Input } from '@angular/core';
import { DashboardV2SubmenuGraphsComponent } from './dashboard-v2-submenu-graphs/dashboard-v2-submenu-graphs.component';

@Component({
  selector: 'mnf-dashboard-v2-submenu',
  standalone: true,
  imports: [
    DashboardV2SubmenuGraphsComponent, 
  ],
  templateUrl: './dashboard-v2-submenu.component.html',
  styleUrl: './dashboard-v2-submenu.component.scss'
})
export class DashboardV2SubmenuComponent {

  @Input() profitUser: { beneficio_no_referred: number, beneficio_referred: number, rendimientos: number }

}
